import { _ as __decorate, a as __metadata, B as BaseComponent } from '../index-BC-pnBUl.js';
import { css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import 'lit/directive.js';

var styles = css`:host {
  display: block;
}

:host(:not([active])) {
  display: none;
}

slot[name=label] {
  display: none;
}`;

/**
 * `it-stepper-step` rappresenta un singolo passo all'interno di un componente `it-stepper`.
 *
 * Gestisce sia i metadati del passo (etichetta, icona, stato) sia il contenuto mostrato
 * nell'area del contenuto dello stepper quando il passo è attivo.
 *
 * ## Struttura attesa
 *
 * ```html
 * <it-stepper>
 *   <it-stepper-step icon="it-calendar">
 *     <span slot="label">Primo contenuto</span>
 *     <p>Contenuto del primo step</p>
 *   </it-stepper-step>
 *   <it-stepper-step>
 *     <span slot="label">Secondo contenuto</span>
 *     <p>Contenuto del secondo step</p>
 *   </it-stepper-step>
 * </it-stepper>
 * ```
 *
 * @slot label - Etichetta del passo, mostrata nell'intestazione dello stepper dall'`it-stepper` padre.
 * @slot - Contenuto del passo, mostrato nell'area `steppers-content` quando il passo è attivo.
 */
let ItStepperStep = class ItStepperStep extends BaseComponent {
    constructor() {
        super(...arguments);
        /**
         * Nome dell'icona BSI da mostrare nell'intestazione del passo (variante `icons`).
         * Esempio: `'it-calendar'`, `'it-lock'`, `'it-settings'`.
         */
        this.icon = '';
        /**
         * Indica se il passo è attualmente attivo (contenuto visibile).
         * Gestito automaticamente dall'`it-stepper` padre.
         */
        this.active = false;
        /**
         * Indica se il passo è stato confermato (completato).
         * Gestito automaticamente dall'`it-stepper` padre.
         */
        this.confirmed = false;
    }
    render() {
        return html `<slot name="label"></slot><slot></slot>`;
    }
};
ItStepperStep.styles = styles;
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], ItStepperStep.prototype, "icon", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItStepperStep.prototype, "active", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItStepperStep.prototype, "confirmed", void 0);
ItStepperStep = __decorate([
    customElement('it-stepper-step')
], ItStepperStep);

export { ItStepperStep };
//# sourceMappingURL=it-stepper-step.js.map
